<!--
    file type .....: HTML file: event-messages.component.html
    Created By ....: ianday
    Date ..........: 2/28/24 
-->
<div class="autoclose-container">
    <div class="heading-text-style">Auto-Close Service</div>

    <div class="dwform" style="margin-left:20px">

        <div class="dwform-row-gap"></div>



        <label class="label-field label-field-override">Enable/Disable:</label>
        <label class="form-required"> </label>

        <dw-dropdown [disabled]="!visibleModify"
        [selectedItem]="selectedValue"
        [dataSource]="enabledList"
        [controlWidth]="'180px'"
        (itemSelected)="selectedValue = $event;updateAutoCloseStatus($event)"></dw-dropdown>

        <div class="dwform-row-gap"></div>
        <div class="dwform-row-gap"></div>

        <label class="label-field label-field-override">Service Status:</label>
        <label class="form-required"> </label>
        <label [ngStyle]="settingsRecord.value === 'true' ? {'color':'green'} : {'color':'red'}">
            {{currentRunState}}
        </label>


        <div class="dwform-row-gap"></div>
    </div>
</div>
